export default __webpack_public_path__ + "assets/e2ed775d4c406ea2a8104a392ed62707.png";